import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';

import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { App } from '../common/App';
import { ApolloProvider } from '@apollo/client';
import { client } from './__graphql__/client';

const Client: React.FC = () => {
  return (
    <HelmetProvider>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </HelmetProvider>
  );
};

loadableReady(() => {
  const mount = document.getElementById('root');
  ReactDOM.render(<Client />, mount);
});
